import { reduxForm, getFormValues } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { MealTypeOptions } from './../helpers/ItemSummaryObjects';
import { RangeDatePickerField } from 'Common/SemanticWrapper';
import { ITEM_SUMMARY_FORM_NAME } from 'Common/FormEnum';
import { ItemSummaryFieldEnum } from 'Common/FieldEnum';
import { rangeDateValidator } from 'Common/FormHelper';
import { SiteComponent } from 'Common/SiteComponent';
import { TitledCard } from 'Components';

class ItemSummaryForm extends Component {
  render() {
    const { isFetching, dispatch, formValues } = this.props;

    const style = {
      height: '100px',
      marginTop: '20px',
      width: '35vw',
      maxWidth: '400px',
      minWidth: '340px',
    };

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <SiteComponent
                  name={ItemSummaryFieldEnum.Site}
                  label={'Site'}
                  {...this.props}
                  isForm={true}
                  disabled={isFetching}
                />
              </Grid.Column>
            </Grid.Row>
            <div style={style}>
              <RangeDatePickerField
                fromName={ItemSummaryFieldEnum.From}
                toName={ItemSummaryFieldEnum.To}
              />
            </div>
            <Grid.Row>
              <Grid.Column className="input-group--btn-group">
                <ReduxFormButtonGroup
                  label={'Meal Type'}
                  dispatch={dispatch}
                  formName={ITEM_SUMMARY_FORM_NAME}
                  fieldName={ItemSummaryFieldEnum.MealType}
                  value={
                    formValues
                      ? formValues[ItemSummaryFieldEnum.MealType]
                      : undefined
                  }
                  disabled={isFetching}
                  options={MealTypeOptions}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values =>
  rangeDateValidator(
    values[ItemSummaryFieldEnum.From],
    values[ItemSummaryFieldEnum.To]
  );

const mapStateToProps = state => {
  return {
    formValues: getFormValues(ITEM_SUMMARY_FORM_NAME)(state),
  };
};

ItemSummaryForm = connect(mapStateToProps)(ItemSummaryForm);

export default reduxForm({
  validate,
  form: ITEM_SUMMARY_FORM_NAME,
  enableReinitialize: true,
})(ItemSummaryForm);



// WEBPACK FOOTER //
// ./src/pages/itemsummary/components/ItemSummaryForm.js